import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import GitHubIcon from "@mui/icons-material/Facebook";
import { Link } from "react-router-dom";

function Footer() {

  const githubUrl = () => {
    window.open('https://facebook.com')
  }

  const instagramUrl = () => {
    window.open('https://www.instagram.com')
  }
  const discordUrl = () => {
    window.open('https://youtube.com')
  }
  return (
    <div className="footer">
      <h1>
        <span className="white">BERGA</span>
        <span className="blue">アニメ</span>
      </h1>
      <p className="footer-about">
        BERGAアニメ is not affiliated with or endorsed by any of the anime studios
        behind the creation of the anime presented on this site. This website is
        only an user interface presenting/linking various self-hosted files
        across the internet by other third-party providers for easy access.
        BERGAアニメ never downloads the video from any source provider, link will
        be returned from the response hence it is completely not subjected to
        DMCA compliant.
      </p>
      <Link to="/terms" className="terms">Terms and conditon</Link>
      <div className="footer-social">
      <button onClick={()=>discordUrl()} aria-label="youtube icon"><i class="fa-brands fa-youtube"></i></button>
        <button onClick={() => instagramUrl()} aria-label="instagram icon">
          <InstagramIcon/>
        </button>
        <button onClick={() => githubUrl()} aria-label="github icon">
          <GitHubIcon />
        </button>
      </div>
    </div>
  );
}
export default Footer;
